// extracted by mini-css-extract-plugin
module.exports = {"field":"Field_field__3eEJq","dots":"Field_dots__3qzFS","snake":"Field_snake__1JwcU","food":"Field_food__VzeZm"};